import './addressVerificationButton.scss';

export const AddressVerificationButton = angular
    .module('checkout.components.addressVerificationForm.button', [])
    .component('addressVerificationButton', {
        transclude: true,
        template: `
            <button
                class="address-verification-button"
                ng-disabled="$ctrl.disabled"
                ng-class="{
                    'address-verification-button--text': $ctrl.variant === 'text',
                    'address-verification-button--primary': $ctrl.variant === 'primary'
                }"
                type="button"
                ng-click="$ctrl.onClick({ $event: $event })"
            >
                <div layout="flex" layout-align="center center">
                    <ng-transclude />
                </div>
            </button>
        `,
        bindings: {
            onClick: '&',
            variant: '<',
            disabled: '<'
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/addressVerificationForm/addressVerificationButton.js